var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M15 0l7.007 7.007L23 8l-1.01 1.01L15 16l-1.41-1.41L19.17 9H.996V7H19.17l-5.58-5.59z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 23 0)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M-5-9h34v34H-5z",
    mask: "url(#b)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftIcon);
export default __webpack_public_path__ + "static/media/left_icon.e26c4e2635a82cc42bfb7e3523701571.svg";
export { ForwardRef as ReactComponent };